<div #uplotContainer class="uplot-container">
  <!--  <p style="position: absolute; z-index: 99">scale: {{debugGetScale()}}</p>-->
  @if (uplot) {
    <app-heatmap-legend
      [heatmapPaletteColors]="heatmapPaletteColors"
      [uplot]="uplot"
    ></app-heatmap-legend>
  }
</div>
